import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MUICheckBox } from '@mui/material'
export default function Checkbox(props) {
    const { name, label, value, onChange, ...rest } = props;
    // console.log(value)
    const handleOnChange = (name,checked , value) => ({
        traget: {
            name,
            value,
            checked
        }
    })
    return (
        <FormControl>
            <FormControlLabel
                control={
                    <MUICheckBox
                        name={name}
                        value={value}
                        onChange={e => onChange(handleOnChange(name, e.target.checked , e.target.value))}
                        color="primary"
                        {...rest}
                    />
                }
                label={label}
            />
        </FormControl>
    )
}
